import { RedemptionChannelRequestModel } from "libs/models/branches";
import { ValidationModel } from "libs/models/validate-model";
import { RedemptionChannelStore } from "store/slices/redemption-channel";
import translate from "utils/translations";

export const ValidateAddRedemptionChannelState = (
  state: RedemptionChannelStore,
): ValidationModel<RedemptionChannelRequestModel> => {
  let validationModel = {} as ValidationModel<RedemptionChannelRequestModel>;
  if (!state.isValidating) {
    return validationModel;
  }

  if (state.newRedemptionChannelData.clientId === undefined) {
    validationModel.clientId = translate(
      "Required_Text",
      "This field is required",
    );
  }
  if (
    state.newRedemptionChannelData.street === null ||
    state.newRedemptionChannelData.street === ""
  ) {
    validationModel.street = translate(
      "Required_Text",
      "This field is required",
    );
  }
  if (
    state.newRedemptionChannelData.street === null ||
    state.newRedemptionChannelData.street.length > 100
  ) {
    validationModel.street = translate("Long_Text", "Text is too long");
  }

  if (
    state.newRedemptionChannelData.buildingNumber === null ||
    state.newRedemptionChannelData.buildingNumber === ""
  ) {
    validationModel.buildingNumber = translate(
      "Required_Text",
      "This field is required",
    );
  }
  if (
    state.newRedemptionChannelData.buildingNumber === null ||
    state.newRedemptionChannelData.buildingNumber.length > 5
  ) {
    validationModel.buildingNumber = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO",
    );
  }
  if (
    state.newRedemptionChannelData.contactNumber === null ||
    state.newRedemptionChannelData.contactNumber === ""
  ) {
    validationModel.contactNumber = translate(
      "Required_Text",
      "This field is required",
    );
  }
  if (state.newRedemptionChannelData.areaId === undefined) {
    validationModel.areaId = translate(
      "Required_Text",
      "This field is required",
    );
  }

  if (state.newRedemptionChannelData.governorateId === undefined) {
    validationModel.governorateId = translate(
      "Required_Text",
      "This field is required",
    );
  }

  const phoneRegex = /^\d{4,11}$/;
  if (
    state.newRedemptionChannelData.contactNumber !== "" &&
    !phoneRegex.test(state.newRedemptionChannelData.contactNumber)
  ) {
    validationModel.contactNumber = translate("Phone_Error", "Invalid phone");
  }

  return validationModel;
};
